export const searchLocale = {
    clear: 'Clear',
};
//# sourceMappingURL=Search.locale.mjs.mjs.map